import { createSlice } from '@reduxjs/toolkit';
import { updateAlertSettings } from '../../../rtk-apis/clinics/updateAlertSettings';
import type { AlertSettingsResult } from './getAlertSettings';

const initialState = {
  status: '',
  result: null as AlertSettingsResult,
  msg: '',
  loading: false,
};

const updateAlertSettingsSlice = createSlice({
  name: 'updateAlertSettings',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(updateAlertSettings.pending, state => {
        state.loading = true;
      })
      .addCase(updateAlertSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload?.result;
        state.msg = action?.payload?.msg;
      })
      .addCase(updateAlertSettings.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default updateAlertSettingsSlice.reducer;
export const { clearState } = updateAlertSettingsSlice.actions;
